import Seo from '@/components/base/Seo';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background-50 pt-24 pb-16 px-6">
      <Seo
        title="Privacy Policy | Healing & Breakthrough"
        description="Privacy Policy for Healing & Breakthrough. Learn how we collect, use, and protect your personal information when you visit our website."
        canonicalPath="/privacy-policy"
      />
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer mb-8"
        >
          <i className="ri-arrow-left-line" aria-hidden="true"></i>
          Back to Home
        </Link>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-primary-800 mb-8">
          Privacy Policy
        </h1>
        <div className="space-y-6 text-sm text-foreground-600 leading-relaxed">
          <p>
            This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make contact through healing-breakthrough.com.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Personal Information We Collect
          </h2>
          <p>
            When you visit the site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the site, we collect information about the individual web pages that you view and information about how you interact with the site.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            How We Use Your Personal Information
          </h2>
          <p>
            We use the information that we collect to help us screen for potential risk and fraud, and more generally to improve and optimize our site.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Sharing Your Personal Information
          </h2>
          <p>
            We do not share your personal information with third parties except as necessary to provide our services or as required by law.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Your Rights
          </h2>
          <p>
            If you are a European resident, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Contact Us
          </h2>
          <p>
            For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at{" "}
            <a href="mailto:federica.tedeschi3@gmail.com" className="text-primary-600 hover:underline">
              federica.tedeschi3@gmail.com
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}